import firebase from 'firebase/app'
import { GameLog, CutinLog } from '@/class/game'

export class History {
  public logs: GameLog[] = []
  public cutinLogs: CutinLog[] = []
  public roomId = ''
  public gameId = ''
  private listenStartAt = Date.now()
  private collection: firebase.firestore.CollectionReference;
  private query: firebase.firestore.Query;

  constructor (roomId: string, gameId: string) {
    this.roomId = roomId
    this.gameId = gameId

    this.collection = firebase.firestore().collection(this.collectionPath)
    this.query = this.collection.orderBy('timestamp', 'asc')
    this.query.onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const log = change.doc.data() as GameLog
          this.logs.push(log)

          if (this.listenStartAt < log.timestamp.toMillis()) {
            if (this.isCutinLog(log)) {
              this.cutinLogs.push(log)
            }
          }
        }
      })
    })
  }

  private get collectionPath() {
    return `room/${this.roomId}/game/${this.gameId}/history`
  }

  public async addBackLog (log: GameLog) {
    await this.collection.add({
      ...log,
      timestamp: firebase.firestore.Timestamp.now()
    })
  }

  private isCutinLog(log: GameLog) {
    return log.roleComingOut || log.selfProclaimNotice || log.policeResult || log.investigatorResult
  }
}
